// Firewall/VAPT subscriptions store their free-text details in selected_plan
// and have no OS, specs or pricing. VPS/Cloud (and legacy rows) return null.
const SECURITY_SERVICES = {
  FIREWALL: { label: 'Firewall', detailLabel: 'Firewall Type' },
  VAPT: { label: 'VAPT', detailLabel: 'VAPT Details' },
};

export const securityService = (subscription) => SECURITY_SERVICES[subscription?.serviceType] || null;
